// extracted by mini-css-extract-plugin
export default {"container":"H6z0kmjZNf0DLtHOMda5","logo":"EVpW3GeQl_ycjXmOXbEr","title":"FuE57UjaUyDrfd76HOAd","description":"r4fno3DFwuFdWlMTIgqk"};